import BaseAction from './BaseAction.js';
import Track from 'track/Track.js';
import AddStepAction from './addStepAction.js';

class DeleteStepNumberAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    // stepNumber can be a floating value, indicating
    // the unquantized offset
    // Any mutation of the step pattern for any track
    // which requires adding a step must come through here
    execute({track, stepNumber, resolution=Track.baseResolution}) {
        let p = track.getEasyPattern();
        let steps = p.getStepsAtStepNumber(stepNumber, resolution);
        let copiedSteps = steps.map(x => ({
            ... x,
            step: x.step.getCopy()
        }));
        p.deleteSteps(steps.map(x => x.step));

        track.updateSteps();
        return {stepsDeleted: copiedSteps};
    }

    undo(action) {
        // we instead add it back!
    }
}

export default DeleteStepNumberAction;
